import { gql } from '@apollo/client';

export const scheduledReportAttributes = gql`
  {
    _id
    contactId
    contact {
      _id
      fullName
    }
    regionCode
    regionName
    reportType
    notes
    adminNotes
    submittedAt
    isSubmitted
    isApproved
    status
    approval {
      status
      when
    }
    scheduleId
    scheduleEntryId
    templateId
    frequency
    dueDate
    formData
    holisticProjectId
    holisticProject {
      _id
      projectName
      projectNumber
      projectNo
      region
      regionCode
      regionalCoordinator {
        _id
        fullName
      }
    }
    humanReadableId
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
`;

export const scheduledReportListAttributesAdmin = gql`
  {
    _id
    contactId
    contact {
      _id
      fullName
    }
    regionCode
    regionName
    reportType
    status
    submittedAt
    isSubmitted
    isApproved
    scheduleId
    scheduleEntryId
    templateId
    frequency
    dueDate
    holisticProjectId
    holisticProject {
      _id
      projectName
      projectNumber
      projectNo
    }
    humanReadableId
    createdAt
    updatedAt
  }
`;

export const scheduledReportForAdminQuery = gql`
  query ScheduledReportForAdmin($_id: ID!) {
    scheduledReportForAdmin(_id: $_id) ${scheduledReportAttributes}
  }
`;

export const allScheduledReportsForAdminQuery = gql`
  query AllScheduledReportsForAdmin(
    $first: Int
    $after: String
    $filters: ScheduledReportFiltersForAdmin
    $sortBy: [SortBy]
  ) {
    allScheduledReportsForAdmin(
      first: $first
      after: $after
      filters: $filters
      sortBy: $sortBy
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node ${scheduledReportListAttributesAdmin}
      }
    }
  }
`;

export const extractAllScheduledReportsForAdmin = (data) =>
  data?.allScheduledReportsForAdmin;

export const extractScheduledReportForAdmin = (data) =>
  data?.scheduledReportForAdmin;

export const createScheduledReportForAdminMutation = gql`
  mutation CreateScheduledReportForAdmin(
    $report: ScheduledReportCreateInputForAdmin!
  ) {
    createScheduledReportForAdmin(report: $report) {
      report ${scheduledReportAttributes}
    }
  }
`;

export const updateScheduledReportForAdminMutation = gql`
  mutation UpdateScheduledReportForAdmin(
    $report: ScheduledReportUpdateInputForAdmin!
  ) {
    updateScheduledReportForAdmin(report: $report) {
      report ${scheduledReportAttributes}
    }
  }
`;

export const submitScheduledReportForAdminMutation = gql`
  mutation SubmitScheduledReportForAdmin($reportId: ID!) {
    submitScheduledReportForAdmin(reportId: $reportId) {
      report ${scheduledReportAttributes}
    }
  }
`;

export const reviewScheduledReportForAdminMutation = gql`
  mutation ReviewScheduledReportForAdmin(
    $reportId: ID!
    $status: ReportApprovalStatus!
  ) {
    reviewScheduledReport(reportId: $reportId, status: $status)
  }
`;

export const deleteScheduledReportForAdminMutation = gql`
  mutation DeleteScheduledReportForAdmin($_id: ID!) {
    deleteScheduledReportForAdmin(_id: $_id) {
      deletedId
    }
  }
`;

export const scheduledReportUpdatesForAdminSubscription = gql`
  subscription ScheduledReportUpdatesForAdmin($_id: ID!) {
    scheduledReportUpdatesForAdmin(_id: $_id) {
      crud
      id
      new ${scheduledReportAttributes}
    }
  }
`;

export const scheduledReportAttributesForUser = gql`
  {
    _id
    contactId
    contact {
      _id
      fullName
    }
    regionCode
    reportType
    notes
    submittedAt
    isSubmitted
    isApproved
    status
    approval {
      status
      when
    }
    scheduleId
    scheduleEntryId
    templateId
    frequency
    dueDate
    formData
    holisticProjectId
    holisticProject {
      _id
      projectName
      projectNumber
      projectNo
      region
      regionCode
    }
    humanReadableId
    createdBy
    createdAt
    updatedAt
  }
`;

// User-side queries
export const scheduledReportForUserQuery = gql`
  query ScheduledReportForUser($_id: ID!) {
    scheduledReportForUser(_id: $_id) ${scheduledReportAttributesForUser}
  }
`;

export const allScheduledReportsForUserQuery = gql`
  query AllScheduledReportsForUser(
    $first: Int
    $after: String
    $filters: ScheduledReportFiltersForUser
    $sortBy: [SortBy]
  ) {
    allScheduledReportsForUser(
      first: $first
      after: $after
      filters: $filters
      sortBy: $sortBy
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node ${scheduledReportAttributesForUser}
      }
    }
  }
`;

export const extractAllScheduledReportsForUser = (data) =>
  data?.allScheduledReportsForUser;

export const createScheduledReportForUserMutation = gql`
  mutation CreateScheduledReportForUser(
    $report: ScheduledReportCreateInputForUser!
  ) {
    createScheduledReportForUser(report: $report) {
      report ${scheduledReportAttributesForUser}
    }
  }
`;

export const updateScheduledReportForUserMutation = gql`
  mutation UpdateScheduledReportForUser(
    $report: ScheduledReportUpdateInputForUser!
  ) {
    updateScheduledReportForUser(report: $report) {
      report ${scheduledReportAttributesForUser}
    }
  }
`;

export const submitScheduledReportForUserMutation = gql`
  mutation SubmitScheduledReportForUser($reportId: ID!) {
    submitScheduledReportForUser(reportId: $reportId)
  }
`;
